import React from 'react';
import * as S from './CTACard.styles';

export interface CTACardProps {
  icon: React.ReactNode;
  title: string;
  subtitle?: string;
  buttonText?: string | React.ReactNode;
  onClick?: () => void;
  onButtonClick?: (e: React.MouseEvent) => void;
  className?: string;
}

const CTACard: React.FC<CTACardProps> = ({ icon, title, subtitle, buttonText, onClick, onButtonClick, className }) => {
  const handleButtonClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (onButtonClick) {
      onButtonClick(e);
    } else if (onClick) {
      onClick();
    }
  };

  return (
    <S.CTACard onClick={onClick} className={className}>
      <S.CTACardContent>
        <S.CTACardIcon>{icon}</S.CTACardIcon>
        <S.CTACardText>
          <S.CTACardTitle>{title}</S.CTACardTitle>
          {subtitle && <S.CTACardSubtitle>{subtitle}</S.CTACardSubtitle>}
        </S.CTACardText>
      </S.CTACardContent>
      {buttonText && <S.CTALinkButton onClick={handleButtonClick}>{buttonText}</S.CTALinkButton>}
    </S.CTACard>
  );
};

export default CTACard;
